import { combineReducers } from 'redux';
import transferOrderList from './TransferOrderList/reducer';
import createEditTransfer from './createEditTransfer/reducer';

export default combineReducers({
  transferOrderList,
  createEditTransfer,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/reducers.js